import { z } from 'zod';

const TASK_NAME_MAX_LENGTH = 256;
const TASK_NAME_MIN_LENGTH = 1;

export const TaskDetailsSchema = z.object({
  name: z
    .string()
    .min(TASK_NAME_MIN_LENGTH, { message: 'กรุณากรอกชื่อ Task' })
    .max(TASK_NAME_MAX_LENGTH, {
      message: `ชื่อ Task ต้องมีความยาวไม่เกิน ${TASK_NAME_MAX_LENGTH} ตัวอักษร`,
    }),
  assignee: z.object(
    {
      label: z.string(),
      value: z.string(),
      inputValue: z.string().nullish(),
    },
    { message: 'กรุณาเลือก Assignee' },
  ),
  dueDate: z.date({ message: 'กรุณาเลือกวันที่' }),
});

export const SubtaskDetailsSchema = z.object({
  assignee: z.object(
    {
      label: z.string(),
      value: z.string(),
      inputValue: z.string().nullish(),
    },
    { message: 'กรุณาเลือก Assignee' },
  ),
  dueDate: z.date({ message: 'กรุณาเลือกวันที่' }),
  qSetId: z.string().uuid(),
});

export const QSetReviewTaskDetailsFormSchema = z.object({
  mainTask: TaskDetailsSchema,
  subtask: z.record(z.string(), SubtaskDetailsSchema),
});

export type QSetReviewTaskDetailsFormInput = z.infer<typeof QSetReviewTaskDetailsFormSchema>;
